import { render, staticRenderFns } from "./NewUserProfile.vue?vue&type=template&id=a9d1af86"
import script from "./NewUserProfile.vue?vue&type=script&lang=js"
export * from "./NewUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports